export enum SelfGuidedTourCategory {
    ALTERNATIVE = 'ALTERNATIVE',
    ARCHITECTURE = 'ARCHITECTURE',
    ART_AND_CULTURE = 'ART_AND_CULTURE',
    CULINARY = 'CULINARY',
    DARK_HISTORY = 'DARK_HISTORY',
    FILM_AND_TV = 'FILM_AND_TV',
    HISTORY = 'HISTORY',
    LOCAL_LIFE = 'LOCAL_LIFE',
    NATURE_AND_PARKS = 'NATURE_AND_PARKS',
    SHOPPING = 'SHOPPING',
    SPIRITUAL = 'SPIRITUAL',
}

export const SELF_GUIDED_TOUR_CATEGORY_LABELS: Record<SelfGuidedTourCategory, string> = {
    ALTERNATIVE: 'Alternative',
    ARCHITECTURE: 'Architectural',
    ART_AND_CULTURE: 'Art & Culture',
    CULINARY: 'Culinary',
    DARK_HISTORY: 'Dark History',
    FILM_AND_TV: 'Film & TV',
    HISTORY: 'Historic',
    LOCAL_LIFE: 'Local Life',
    NATURE_AND_PARKS: 'Nature & Parks',
    SHOPPING: 'Shopping',
    SPIRITUAL: 'Spiritual',
};